<section class="task-summary-card" aria-labelledby="task-summary-title">
  <div class="task-summary-header">
    <div>
      <h2 id="task-summary-title">Resumen de tareas</h2>
      <p>{{ rangeLabel() }}</p>
    </div>
    <div class="task-summary-filters">
      <div class="task-summary-filter">
        <label for="task-summary-client-type">Tipo de cliente</label>
        <select
          id="task-summary-client-type"
          class="form-select"
          [ngModel]="clientType()"
          (ngModelChange)="changeClientType($event)"
        >
          @for (option of clientTypeOptions; track option.label) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div class="task-summary-filter">
        <label for="task-summary-period">Periodo</label>
        <select
          id="task-summary-period"
          class="form-select"
          [ngModel]="period()"
          (ngModelChange)="changePeriod($event)"
        >
          @for (option of periodOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="task-summary-content" [attr.aria-busy]="isLoading()">
    <div class="task-summary-chart">
      @if (isLoading()) {
        <div class="task-summary-state">
          <fa-icon [icon]="icons.faSpinner" [animation]="'spin'"></fa-icon>
          <span>Cargando resumen…</span>
        </div>
      } @else if (hasError()) {
        <div class="task-summary-state task-summary-state-error">
          <span>No fue posible cargar el resumen.</span>
          <button type="button" class="btn btn-sm btn-outline-dark" (click)="loadTaskSummary()">Reintentar</button>
        </div>
      } @else if (total() === 0) {
        <div class="task-summary-state">
          <span>No hay tareas para este periodo.</span>
        </div>
      } @else {
        <a
          class="task-summary-chart-link"
          routerLink="/maintenances"
          aria-label="Abrir Calendario de eventos"
        >
          <ngx-charts-pie-chart
            aria-hidden="true"
            [results]="data()"
            [scheme]="colorScheme"
            [legend]="false"
            [labels]="false"
            [doughnut]="false"
            [gradient]="false"
            [animations]="true"
          ></ngx-charts-pie-chart>
        </a>
      }
    </div>

    <div class="task-summary-legend">
      @for (status of legend(); track status.name) {
        <a
          class="task-summary-legend-item"
          routerLink="/maintenances"
          [attr.aria-label]="'Abrir Calendario de eventos: ' + status.label + ', ' + status.value"
        >
          <span class="task-summary-dot" [style.background-color]="status.color"></span>
          <span class="task-summary-label">{{ status.label }}</span>
          <strong>{{ status.value }}</strong>
        </a>
      }
      <div class="task-summary-total">
        <span>Total</span>
        <strong>{{ total() }}</strong>
      </div>
    </div>
  </div>
</section>
